<template>
  <div class="tabs">
    <button
      type="button"
      v-for="{ label, icon } in views"
      :key="label"
      @click="setActiveView(label)"
      class="tab"
      :class="[{ 'active-view': viewActive(label) }, `${label}-tab`]"
    >
      <component
        :view-active="viewActive(label)"
        class="icon"
        :is="icon"
      />
      <span>{{ label }}</span>
    </button>
  </div>
</template>

<script>
import { views, store } from './../store.js';
import { createWidgetMixin } from 'vue-instantsearch';
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';

export default {
  mixins: [createWidgetMixin({ connector: connectCurrentRefinements })],
  data() {
    return {
      views,
      storeState: store.state,
    };
  },
  methods: {
    setActiveView(activeView) {
      if (activeView !== 'Filters'){
        window.sessionStorage.setItem('algolia_currentView', activeView);
      }
      store.setActiveView(activeView);
    },
    viewActive(label) {
      if (label === 'Filters') {
        return this.state && this.state.items.length > 0;
      }
      return this.storeState.activeView === label;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  margin: .5em;
}

.tab {
  display: flex;
  margin: 0 4px;
  padding: 6px 10px;
  background: none;
  font-family: inherit;
  font-size: 14px;
  color: $black;
  outline: none;
  cursor: pointer;
  border: solid 1px $black;
  align-items: center;

  @media screen and(max-width: $mobile) {
    margin: 0 1px;
    padding: 6px 6px;
  }
}

.icon {
  display: block;
  height: 100%;
  max-height: 20px;
  max-width: 20px;
  width: 18px;
  margin-right: 8px;
  flex-grow: 0;
  flex-shrink: 0;
}

.active-view {
  @include theme-value(background, brand-color-one);
  @include theme-value(border-color, brand-color-one);
  color: $white;
  fill: $white;

  .gourmet-society & {
    background: $black;
    border-color: $black;
  }
}

.Filters-tab {
  @media screen and (min-width: $tablet + 1) {
    display: none;
  }
}

@media screen and (max-width: $tiny-mobile) {
  .Grid-tab {
    display: none;
  }

  // @extend doesn't work in media query?
  .List-tab {
    @include theme-value(background, brand-color-one);
    @include theme-value(border-color, brand-color-one);
    color: $white;
    fill: $white;

    .gourmet-society & {
      background: $black;
      border-color: $black;
    }
  }
}
</style>
